"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Component = _interopRequireDefault(require("./Component.js"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'geometric',
  label: 'Geometric',
  component: _Component["default"],
  thumbnail: _thumbnail["default"],
  flowPlayerSettings: {
    background: 'solidColor',
    backgroundColor: '#fff'
  }
};